import {
  faChartPie,
  faClipboardCheck,
  faCode,
  faComments,
  faHeadset,
  faHeart,
  faUser,
  faUserShield,
  faUserTie,
  faVialCircleCheck
} from "@fortawesome/free-solid-svg-icons";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { getPermissionIDRequired } from "../../helpers/et3-has-permission";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import MenuDropdownItem from "./side-bar-menu/MenuDropdownItem";
import MenuItem from "./side-bar-menu/MenuItem";
import ET3Div from "../../core/et3-div";
import getRoutingStore from "../../stores/routing";
import { SIDE_BAR_MENU_PADDING_X } from "./side-bar-constants";

const SideBarMenu = withLiteObserverAndTheme<{ isAlert: boolean }>((props) => {
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const { theme, isAlert } = props;
  const { colors, unitX } = theme;
  const isManualKhattabaAdmin =
    getCorePersonalStore().isManualKhattabaAdmin.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={840}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={isAlert ? colors.all.red : colors.all.darkSlateGray}
      style={{
        boxSizing: "border-box",
        height: "auto",
        minHeight: 0,
        flexShrink: 0,
        paddingLeft: SIDE_BAR_MENU_PADDING_X * unitX,
        paddingRight: SIDE_BAR_MENU_PADDING_X * unitX
      }}
      onClick={() => {}}
    >
      <MenuDropdownItem
        onPress={() => null}
        visible={userPermissions.indexOf(getPermissionIDRequired("User")) > -1}
        title={i18n.get("USER")}
        icon={faUser}
        options={getRoutingStore().USER_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().userDropdownIsOpen}
      />

      <MenuDropdownItem
        visible={
          userPermissions.indexOf(getPermissionIDRequired("CSR")) > -1 &&
          !isAnyKhattabaAdmin
        }
        title={i18n.get("CSR")}
        icon={faHeadset}
        options={getRoutingStore().CSR_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().CSRDropdownIsOpen}
        onPress={async () => {}}
      />
      <MenuDropdownItem
        visible={userPermissions.indexOf(getPermissionIDRequired("SCSR")) > -1}
        title={i18n.get("SCSR")}
        icon={faUserShield}
        options={getRoutingStore().SCSR_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().scsrDropdownIsOpen}
        onPress={async () => {}}
      />
      <MenuDropdownItem
        visible={
          userPermissions.indexOf(getPermissionIDRequired("Auditor")) > -1
        }
        title={i18n.get("AUDITOR")}
        icon={faClipboardCheck}
        options={getRoutingStore().AUDITOR_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().AuditorDropdownIsOpen}
        onPress={async () => {}}
      />
      <MenuDropdownItem
        visible={
          userPermissions.indexOf(getPermissionIDRequired("Supervisor")) > -1 &&
          !isAnyKhattabaAdmin
        }
        title={i18n.get("SUPERVISOR")}
        icon={faUserTie}
        options={getRoutingStore().SUPERVISOR_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().supervisorDropdownIsOpen}
        onPress={async () => {}}
      />
      <MenuDropdownItem
        onPress={() => null}
        visible={
          userPermissions.indexOf(getPermissionIDRequired("Communications")) >
            -1 && !isAnyKhattabaAdmin
        }
        title={i18n.get("COMMUNICATIONS")}
        icon={faComments}
        options={getRoutingStore().COMMUNICATION_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().communicationZoneDropdownIsOpen}
      />
      <MenuDropdownItem
        onPress={() => null}
        visible={
          userPermissions.indexOf(getPermissionIDRequired("QA")) > -1 &&
          !isAnyKhattabaAdmin
        }
        title={i18n.get("QA")}
        icon={faVialCircleCheck}
        options={getRoutingStore().QA_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().qaZoneDropdownIsOpen}
      />
      <MenuDropdownItem
        onPress={() => null}
        visible={
          userPermissions.indexOf(getPermissionIDRequired("Developer")) > -1 &&
          !isAnyKhattabaAdmin
        }
        title={i18n.get("DEV_ZONE")}
        icon={faCode}
        options={getRoutingStore().DEV_ZONE_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().devZoneDropdownIsOpen}
      />
      <MenuDropdownItem
        onPress={() => null}
        visible={
          userPermissions.indexOf(getPermissionIDRequired("Khattabat")) > -1 &&
          !isAnyKhattabaAdmin
        }
        title={i18n.get("KHATTABAT")}
        icon={faUser}
        options={getRoutingStore().KHATTABAT_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().khattabatDropdownIsOpen}
      />

      <MenuItem
        visible={
          userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
          isManualKhattabaAdmin
        }
        title={i18n.get("MATCHMAKING")}
        icon={faHeart}
        link="/khattabatMatching/searchAnd1O1M"
      />
      <MenuItem
        visible={
          userPermissions.indexOf(getPermissionIDRequired("ShareHolder")) >
            -1 && !isAnyKhattabaAdmin
        }
        title={i18n.get("SHAREHOLDER_DASHBOARD")}
        icon={faChartPie}
        link="/shareholder/dashboard"
      />
    </ET3Div>
  );
});
export default SideBarMenu;
